exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-73a83a1d]{font-size:15px;text-align:justify}h1[data-v-73a83a1d]{color:#fff}", ""]);

// exports
